import React from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Table,
  Button
} from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import config from "../../config/config";

import "./destinations.scss";

function DestinationsList() {
  const navigate = useNavigate();
  const [destinations, setDestinations] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);
  const breadcrumbItems = [
    { title: "Destionations", link: "#" },
    { title: "Destionations List", link: "#" },
  ];

  React.useEffect(() => {
    fetchDestinations();
  }, []);

  const fetchDestinations = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${config.API_BASE_URL}/destinations`);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      console.log('Destinations data:', data);
      
      // Handle different response formats
      if (Array.isArray(data)) {
        setDestinations(data);
      } else if (data.data && Array.isArray(data.data)) {
        setDestinations(data.data);
      } else if (Array.isArray(data.destionations)) {
        setDestinations(data.destionations);
      } else {
        console.warn('Unexpected data format:', data);
        setDestinations([]); // Set to empty array if format is unexpected
      }
    } catch (error) {
      console.error('Error fetching destinations:', error);
      setError(error.message);
      setDestinations([]); // Ensure it's always an array
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (destinations) => {
    navigate(`/edit-destination/${destinations._id}`, { state: { destinations } });
  };

  const handleDelete = async (destinationsId) => {
    if (window.confirm("Are you sure you want to delete this destinations?")) {
      try {
        const response = await fetch(`${config.API_BASE_URL}/destinations/${destinationsId}`, {
          method: 'DELETE'
        });
        
        if (response.ok) {
          setDestinations(destinations.filter(cat => cat._id !== destinationsId));
        } else {
          console.error('Failed to delete destinations');
        }
      } catch (error) {
        console.error('Error deleting destinations:', error);
      }
    }
  };

  if (loading) {
    return (
      <div className="page-content">
        <Container fluid>
          <div className="text-center">Loading destinations...</div>
        </Container>
      </div>
    );
  }

  if (error) {
    return (
      <div className="page-content">
        <Container fluid>
          <div className="text-center text-danger">Error: {error}</div>
        </Container>
      </div>
    );
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title="Destinations List"
            breadcrumbItems={breadcrumbItems}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <div className="d-flex justify-content-end mb-4">
                    <Link to="/create-destinations">
                      <Button color="primary">
                        <i className="ri-add-line align-middle me-1"></i> Add Destinations
                      </Button>
                    </Link>
                  </div>
                  <div className="table-responsive">
                    <Table className="table table-centered table-nowrap mb-0">
                      <thead>
                        <tr>
                          <th>ID</th>
                          <th>Destinations Name</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {destinations.length === 0 ? (
                          <tr>
                            <td colSpan="5" className="text-center">
                              No destinations found.
                            </td>
                          </tr>
                        ) : (
                          destinations.map((destination, index) => (
                            <tr key={destination._id || index}>
                              <td>{destination._id}</td>
                              <td>{destination.destination_name || 'N/A'}</td>
                              <td>
                                <button 
                                  className="tour-action-buttons me-2"
                                  onClick={() => handleEdit(destination)}
                                >
                                  <i className="ri-pencil-fill"></i>
                                </button>
                                <button 
                                  className="tour-action-buttons text-danger"
                                  onClick={() => handleDelete(destination._id)}
                                >
                                  <i className="ri-delete-bin-fill"></i>
                                </button>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </Table>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default DestinationsList;